import { useMemo } from 'react';
import { TableFilterSelectOption } from '../../components/table-filter-select';
import useEnrichmentMetadataStore from '../../store/enrichment-metadata/enrichment-metadata-store';
import { EnrichmentTypeEnum } from '../../types';

export function useAddEnrichmentTypeMetadata(
  options: TableFilterSelectOption[]
) {
  const { metadata } = useEnrichmentMetadataStore();

  return useMemo(
    () =>
      options.map((o) => ({
        ...o,
        metadata:
          metadata &&
          (o.key !== EnrichmentTypeEnum.ALL
            ? metadata[o.key as EnrichmentTypeEnum]
            : metadata[EnrichmentTypeEnum.COMPANY] +
              metadata[EnrichmentTypeEnum.PERSON] +
              metadata[EnrichmentTypeEnum.EMAIL] +
              metadata[EnrichmentTypeEnum.EMAIL_FINDER] +
              metadata[EnrichmentTypeEnum.EMAIL_VERIFIER]),
      })),
    [metadata, options]
  );
}
